/*!
 * @copyright
 * Copyright(c) 2019 SICK AG
 */

import { Vector2 } from 'three';

export class Hit {
  static improve (a: Hit, b: Hit): Hit {
    return ((b.len <= 0) || (a.len > 0) && (a.len < b.len)) ? a : b;
  }

  static lessThan (a: Hit, b: Hit): boolean {
    return ((b.len <= 0) || (a.len > 0) && (a.len < b.len));
  }

  constructor(public point: Vector2, public dir: Vector2, public len: number) {
  }
}
